export default {
  active: true,
  code: '',
  description: '',
  name: '',
  jobManagementIds: []
};
